/**
 * Rillion Prime API v1.0
 * A REST API endpoint for Role operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BaseModel } from './baseModel';
import { HeadersOnly } from './headersOnly';
import { RowStates } from './rowStates';

export interface RoleModel {
  headersOnly?: HeadersOnly;
  forProcessing?: boolean | null;
  index?: number | null;
  inspected?: boolean | null;
  locked?: boolean | null;
  lockedRowID?: number | null;
  lockedRowLockedTime?: string | null;
  lockedRowLoginName?: string | null;
  lockedRowRole?: string | null;
  lockID?: number | null;
  lockType?: number | null;
  parent?: BaseModel;
  rowState?: RowStates;
  selected?: boolean | null;
  keyValuesRowState?: RowStates;
  role?: string | null;
  name?: string | null;
  userGroup?: string | null;
  active?: boolean | null;
  includableInFlow?: boolean | null;
  roleAdministrator?: string | null;
  roleSupervisor?: string | null;
  powerRole?: string | null;
  reminderArrival?: number | null;
  reminderDueDate?: number | null;
  reminderSupervisor?: number | null;
  forwardSupervisor?: number | null;
  authorizationAmount?: number | null;
  authorizationOutstandingAmountExceed?: number | null;
  authorizationOutstandingAmountBelow?: number | null;
  authorizationOutstandingAmountPercentExceed?: number | null;
  authorizationOutstandingAmountPercentBelow?: number | null;
  permissionGroupBitCode?: number | null;
  selectCompany?: string | null;
  selectAccount?: string | null;
  selectObject1?: string | null;
  selectObject2?: string | null;
  selectObject3?: string | null;
  selectObject4?: string | null;
  selectObject5?: string | null;
  selectObject6?: string | null;
  selectObject7?: string | null;
  selectObject8?: string | null;
  defaultCompany?: string | null;
  defaultObject1Id?: number | null;
  defaultObject2Id?: number | null;
  defaultObject3Id?: number | null;
  defaultObject4Id?: number | null;
  defaultObject5Id?: number | null;
  defaultObject6Id?: number | null;
  defaultObject7Id?: number | null;
  defaultObject8Id?: number | null;
  flowProposalId?: number | null;
  group1?: string | null;
  group2?: string | null;
  group3?: string | null;
  chTime?: string | null;
  chUser?: string | null;
  defaultAddressId?: number | null;
  selectCommodity?: string | null;
  selectExpenseType?: string | null;
  newAuthorizationAmount?: number | null;
  newAuthorizationAmountRole?: string | null;
  newAuthorizationAmountUser?: string | null;
  newAuthorizationAmountDateTime?: string | null;
  reminderImmidiateBitCode?: number | null;
  roleUserLogins?: Array<string> | null;
  roleUserNames?: Array<string> | null;
  roleUserEmails?: Array<string> | null;
  roleCompanies?: Array<string> | null;
}
